import b64toBlob from 'b64-to-blob';
import { reject } from 'lodash';
import { DB_NAME, TICKETS_STORE_NAME, FILES_STORE_NAME, SURVEY_STORE_NAME } from "./StoreNames";

class LocalIndexDB {
  constructor() {
    this.db = null;
    this.opened = false;
  }
  async openDatabase() {
    return new Promise((resolve, reject) => {
      let request = indexedDB.open(DB_NAME);

      let that = this;

      request.onerror = (e) => {
        reject();
      };

      request.onsuccess = (e) => {
        that.db = e.target.result;
        that.opened = true;
        resolve();
      };

      request.onupgradeneeded = (e) => {
        let db = e.target.result;
        if (!db.objectStoreNames.contains(FILES_STORE_NAME)) {
          db.createObjectStore(FILES_STORE_NAME, {
            autoIncrement: false,
            keyPath: "id",
          });
        }
        if (!db.objectStoreNames.contains(SURVEY_STORE_NAME)) {
          db.createObjectStore(SURVEY_STORE_NAME, {
            autoIncrement: false,
            keyPath: "id",
          });
        }
        if (!db.objectStoreNames.contains(TICKETS_STORE_NAME)) {
          db.createObjectStore(TICKETS_STORE_NAME, {
            autoIncrement: false,
            keyPath: "id",
          });
        }
        if (!db.objectStoreNames.contains("app")) {
          db.createObjectStore("app", {
            autoIncrement: false,
            keyPath: "id",
          });
        }
      };
    });
  }
  clearDatabase(except = []) {
    let filesTransaction = this.db.transaction(FILES_STORE_NAME, "readwrite");
    let filesStore = filesTransaction.objectStore(FILES_STORE_NAME);
    let getAllFilesKeysRequest = filesStore.getAllKeys();
    getAllFilesKeysRequest.onsuccess = function () {
      let keys = getAllFilesKeysRequest.result;
      for (let key of keys) {
        if (except.some(v => v.split("_")[1] === key) === false) {
          let deleteRequest = filesStore.delete(key);
          deleteRequest.onerror = function () {
            console.error("Object delete error");
          };
        }
      }
    };
    getAllFilesKeysRequest.onerror = function () {
      console.error("Keys get error");
    };
    filesTransaction.oncomplete = function () { };

    let surveyTransaction = this.db.transaction(SURVEY_STORE_NAME, "readwrite");
    let surveyStore = surveyTransaction.objectStore(SURVEY_STORE_NAME);
    let getAllSurveyKeysRequest = surveyStore.getAllKeys();
    getAllSurveyKeysRequest.onsuccess = function () {
      let keys = getAllSurveyKeysRequest.result;
      for (let key of keys) {
        if (except.some(v => v.split("_")[1] === key) === false) {
          let deleteRequest = surveyStore.delete(key);
          deleteRequest.onerror = function () {
            console.error("Object delete error");
          };
        }
      }
    };
    getAllSurveyKeysRequest.onerror = function () {
      console.error("Keys get error");
    };
    surveyTransaction.oncomplete = function () { };

    let ticketTransaction = this.db.transaction(TICKETS_STORE_NAME, "readwrite");
    let ticketStore = ticketTransaction.objectStore(TICKETS_STORE_NAME);
    let getAllTicketKeysRequest = ticketStore.getAllKeys();
    getAllTicketKeysRequest.onsuccess = function () {
      let keys = getAllTicketKeysRequest.result;
      for (let key of keys) {
        if (except.some(v => v.split("_")[1] === key) === false) {
          let deleteRequest = ticketStore.delete(key);
          deleteRequest.onerror = function () {
            console.error("Object delete error");
          };
        }
      }
    };
    getAllTicketKeysRequest.onerror = function () {
      console.error("Keys get error");
    };
    ticketTransaction.oncomplete = function () { };
  }
  remove(store, id) {
    let transaction = this.db.transaction(store, "readwrite");
    let dbStore = transaction.objectStore(store);
    let request = dbStore.delete(id);
    request.onsuccess = function () { };
    request.onerror = function () {
      throw new Error("Object save error");
    };
    transaction.oncomplete = function () { };
  }
  saveObject(store, id, object) {
    let transaction = this.db.transaction(store, "readwrite");
    let dbStore = transaction.objectStore(store);
    let request = dbStore.put({ id: id, data: object });
    request.onsuccess = function () { };
    request.onerror = function () {
      throw new Error("Object save error");
    };
    transaction.oncomplete = function () { };
  }
  getObject(store, id) {
    let that = this;
    return new Promise((resolve, reject) => {
      let transaction = that.db.transaction(store, "readonly");
      let dbStore = transaction.objectStore(store);
      let request = dbStore.get(id);
      request.onsuccess = function () {
        if (!request.result) {
          reject(id + " is not found");
          return;
        }
        if (!request.result.data) {
          reject(id + " is not found");
          return;
        }
        resolve(request.result.data);
      };
      request.onerror = function () {
        reject(id + " is not found");
      };
      transaction.oncomplete = function () { };
    });
  }
  getStoreObjects(store) {
    let that = this;
    return new Promise((resolve, reject) => {
      let transaction = that.db.transaction(store, "readonly");
      let dbStore = transaction.objectStore(store);
      let request = dbStore.getAll();
      request.onsuccess = function () {
        if (!Array.isArray(request.result)) {
          resolve([]);
          return;
        }
        if (request.result.length === 0) {
          resolve([]);
          return;
        }
        resolve(request.result.map(v => v.data));
      };
      request.onerror = function () {
        reject("unable to get store " + store);
      };
      transaction.oncomplete = function () { };
    });
  }
  saveFile(store, id, file) {
    let that = this;
    return new Promise((resolve, reject) => {
      try {
        let reader = new FileReader();
        reader.onload = (e) => {
          let transaction = that.db.transaction(store, "readwrite");
          let dbStore = transaction.objectStore(store);
          let request = dbStore.put({
            id: id,
            data: file.name + ";" + e.target.result
          });
          request.onsuccess = function () {
            resolve(id);
          };
          request.onerror = function () {
            reject("File save error");
          };
        };
        reader.readAsDataURL(file);
      } catch (err) {
        reject(err);
      }
    });
  }
  getFile(store, id) {
    let that = this;
    return new Promise((resolve, reject) => {
      let transaction = that.db.transaction(store, "readwrite");
      let dbStore = transaction.objectStore(store);
      let request = dbStore.get(id);
      request.onsuccess = function () {
        if (!request.result) {
          reject(id + " is not found");
          return;
        }
        if (!request.result.data) {
          reject(id + " is not found");
          return;
        }
        let data = request.result.data;
        let base64Parts = data.split(';');
        let contentType = base64Parts[1].split(':')[1];
        let b64Data = base64Parts[2].split(',')[1];;
        let blob = b64toBlob(b64Data, contentType);
        blob.name = base64Parts[0]; // file name
        resolve(blob);
      };
      request.onerror = function () {
        reject(id + " is not found");
      };
    }
    );
  }
}

var localIndexDB = new LocalIndexDB();

export default localIndexDB;



// WEBPACK FOOTER //
// ./src/services/LocalDatabase/LocalIndexDB.js